import { DocsHero } from 'components/docs/docs-hero';
import { DocsStartSection } from 'components/docs/docs-start-section';
import { DocsWrapper } from 'components/docs/docs-wrapper';
import { fetchHomepageSections } from 'queries';

const IndexPage = ({ ssr, router, session, store, toast }) => {
	const sections = ssr.sections || [];

	// Render
	return (
		<DocsWrapper seo={{ title: 'Playbooks Docs | Transform ideas into products.' }}>
			<DocsHero
				title='Build fast. Build smart.'
				subtitle='Learn more about Playbooks, our various SDKs, and how to be successful with our platform.'
			/>
			<div className='mx-auto max-w-6xl px-5 sm:px-8'>
				<DocsStartSection sections={sections} />
			</div>
		</DocsWrapper>
	);
};

export async function getServerSideProps() {
	const sections = await fetchHomepageSections();
	return { props: { sections } };
}

export default IndexPage;

// Articles
// https://github.com/hashicorp/next-mdx-remote
